import {useMemo} from "react";
import {Stack, Typography} from "@mui/material";
import {Navigate, useLocation, useParams} from "react-router";
import {appSession} from "../../../TR3AD.ts";
import WidgetHeader from "../../../widgets/WidgetHeader.tsx";
import {appStyles} from "../../../AppStyles.ts";

// Title-cases a URL slug so breadcrumbs survive a hard refresh when router state is lost.
function titleCase(raw: string): string {
    if (!raw) return "";
    return raw
        .split(/[._-]+/)
        .map(p => p.length === 0 ? "" : p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
        .join(" ")
        .trim();
}

type LocationStateShape = {researcher?: {key: string; name: string}};

function UXResearcherResultSelect() {
    const {networkUID, researcherKey} = useParams();
    const location = useLocation();
    const state = (location.state ?? null) as LocationStateShape | null;

    const friendlyName = useMemo(() => {
        if (state?.researcher?.name) return state.researcher.name;
        return titleCase(String(researcherKey ?? ""));
    }, [state, researcherKey]);

    return (
        <Stack direction="column" width="100%" minHeight="100vh">
            {!appSession.activeSession() ? (
                <Navigate to="/" />
            ) : (
                <Stack direction="column" spacing={1} width="99%">
                    <WidgetHeader
                        title={`${friendlyName} Results`}
                        breadcrumbs={[
                            {display: "Networks", linkTo: "/networks/", activeView: false},
                            {display: String(networkUID), linkTo: `/networks/${networkUID}`, activeView: false},
                            {display: "Researchers", linkTo: `/networks/${networkUID}/research`, activeView: false},
                            {display: friendlyName, linkTo: `/networks/${networkUID}/research/${researcherKey}`, activeView: false},
                            {display: "Results", linkTo: "", activeView: true},
                        ]}
                    />
                    <Stack sx={appStyles.sectionBox} spacing={0} width="100%" alignItems="center">
                        <Typography sx={{...appStyles.panelSectionTitle, padding: "16px 0 8px"}}>
                            {friendlyName} Results
                        </Typography>
                        <Typography sx={{color: "rgba(242, 245, 250, 0.5)", fontSize: "0.85rem", padding: "48px 24px", textAlign: "center"}}>
                            Results list will be built out in a future session.
                        </Typography>
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
}

export default UXResearcherResultSelect;
